import React from 'react';


export function Loader() {
    return <div className="QrModalLoader"></div>
}